/*
 * Copyright (c) 2013 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.high_d.axis

import com.macrofocus.high_d.axis.group.AxisGroupModel

enum class Alignment {
    Left {
        override fun getMinimumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 0.0
        }

        override fun getMaximumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 1.0 - 1.0 / axisGroup.visibleAxisCount
        }
    },
    Center {
        override fun getMinimumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 0.0
        }

        override fun getMaximumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 1.0
        }
    },
    Fill {
        override fun getMinimumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 0.0
        }

        override fun getMaximumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 1.0
        }
    },
    Right {
        override fun getMinimumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 1.0 / axisGroup.visibleAxisCount
        }

        override fun getMaximumPosition(axisGroup: AxisGroupModel<*,*>): Double {
            return 1.0
        }
    };

    abstract fun getMinimumPosition(axisGroup: AxisGroupModel<*,*>): Double
    abstract fun getMaximumPosition(axisGroup: AxisGroupModel<*,*>): Double
}